import React from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Field, Form } from 'formik';
import { IonLoading, IonImg, IonButton, IonList, IonText } from '@ionic/react';
import { InputField } from 'components/form';
import AppActions from 'redux/AppRedux';
import { AuthSelectors } from 'redux/AuthRedux';
import { encryptPhone } from 'utils/phone';
import api_v2 from 'services/api_v2';
import schema from './schema';

const INITIAL_VALUES = {
  code: '',
};

function VerifyForm() {
  const dispatch = useDispatch();
  const signupData = useSelector(AuthSelectors.selectSignup);
  const history = useHistory();

  const handleSubmit = async (values, actions) => {
    try {
      await api_v2().verifySmsCode(`+1${signupData.phone}`, values.code);
      dispatch(
        AppActions.setToast('Your phone number was verified', 'success')
      );

      history.push('/auth/signup');
    } catch (e) {
      if (
        e.code === 'USER_ALREADY_EXISTS' ||
        e.code === 'INVALID_VERIFICATION_CODE'
      ) {
        history.push('/auth/signup');
      }

      dispatch(
        AppActions.setToast(e.message || 'Verification failed', 'danger')
      );
    }
    
    actions.setSubmitting(false);
  };

  return (
    <Formik
      initialValues={{ ...INITIAL_VALUES }}
      onSubmit={handleSubmit}
      validationSchema={schema}
    >
      {({ isSubmitting }) => {
        return (
          <Form>
            <IonLoading isOpen={isSubmitting} message="Loading..." />
            <IonList>
              <div className="auth-logo">
                <IonImg src="/assets/vemospay-logo.png" />
              </div>
              <div className="mb-3x">
                <IonText>
                  A text message with your code has been sent to{' '}
                  {signupData && signupData.phone
                    ? encryptPhone(signupData.phone)
                    : ''}
                </IonText>
              </div>
              <Field
                strongLabel
                component={InputField}
                name="code"
                type="tel"
                label="Enter Verification Code"
              />
              <Link to="/auth/sign">
                <IonText color="medium">
                  <small>Problem receiving your code?</small>
                </IonText>
              </Link>
              <br />
              <br />
              <div className="mb-5x mt-3x text-center">
                <IonButton
                  color="tertiary"
                  fill="solid"
                  type="submit"
                  disabled={isSubmitting}
                  className="sign-btn"
                >
                  Verify
                </IonButton>
              </div>
            </IonList>
          </Form>
        );
      }}
    </Formik>
  );
}

export default VerifyForm;
